import React from 'react';
import '../assets/styling/About.css';
import poza1 from '../assets/images/poza1.jpg';
import poza2 from '../assets/images/poza2.webp';

const About = () => {
  return (
    <section className="about-section">
      <div className="about-container">
        <h2 className="about-title">La VIBE9 ai la dispoziție două cadre special concepute pentru podcast-ul tău:</h2>
        
        <div className="images-container">
          <div className="image-wrapper">
            <img src={poza1} alt="Studio setup 1" loading="lazy" />
          </div>
          <div className="image-wrapper">
            <img src={poza2} alt="Studio setup 2" loading="lazy" />
          </div>
        </div>

        <div className="about-text">
          <p>
            Cauți un studio pentru podcast echipat profesional? La VIBE9 îți oferim un spațiu modern,
            dotat cu sunet de ultimă generație și camere 4K, perfect pentru producția podcastului tău.
          </p>
          <p>
            Închiriază studioul nostru și beneficiază de suport tehnic dedicat pentru a-ți transforma ideile
            în conținut de calitate. Rezervă acum și creează un podcast de impact!
          </p>
        </div>
      </div>
    </section>
  );
};

export default About; 